import { GoogleCalendar } from 'datebook'
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import _normalizeUrl from 'normalize-url';

dayjs.extend(duration)


export const trimAddr = (addr: string, n = 3) =>
  addr?.substring(0, n + 2) + '...' + addr?.slice(-n);

export const trimAddr1 = (addr: string, n = 3) =>
  addr?.substring(0, n) + '...' + addr?.slice(-n);

export const trimAddr2 = (addr: string) =>
  addr?.substring(0, 18) + '...' + addr?.slice(-14);

export function twitterUserLink(account: string) {
  return `https://twitter.com/${account}`
}

export function discordUserLink(uid: string) {
  return `https://discordapp.com/users/${uid}`
}

export function googleMapLink(location: string) {
  return `https://www.google.com/maps/place/${location.replaceAll(' ', '+')}`
}

export function telegramUserLink(user: string) {
  return ''
}

export function emailLink(email: string) {
  return `mailto:${email}`
}

export function etherscanAddressLink(address: string) {
  return `https://etherscan.io/address/${address}`
}

export function googleCalendarLink(config: {
  title: string,
  description: string,
  start: Date,
  end: Date,
  location?: string
}) {
  return new GoogleCalendar(config as any).render();
}

export function dateShortDesc(date: Date) {
  const day = dayjs(date);
  if (day.isSame(dayjs(), 'year')) {
    return day.format('MM/DD')
  } else {
    return day.format('MM/DD/YYYY')
  }
}

export function relativeDateDesc(date: Date) {
  const duration = dayjs.duration(dayjs().diff(dayjs(date)))
  const years = duration.asYears();
  const months = duration.asMonths();
  const days = duration.asDays();
  if (years > 1) {
    return `${Math.floor(years)} years ago`;
  } else if (months > 1) {
    return `${Math.floor(months)} month ago`;
  } else if (days > 60) {
    return '>60 days ago'
  } else if (days < 1) {
    return `${Math.floor(duration.hours())} hours ago`
  } else {
    return `${Math.floor(days)} days ago`
  }
}

export function walletAge(date: Date) {
  const duration = dayjs.duration(dayjs().diff(dayjs(date)))
  const years = duration.asYears();
  const months = duration.asMonths();
  const days = duration.asDays();
  if (years > 1) {
    return `${Math.floor(years)} year`
  } else if (months > 1) {
    return `${Math.floor(months)} month`
  } else if (days > 1) {
    return `${Math.floor(days)} day`
  } else {
    return 'today';
  }
}

export function lastActiveDesc(date: Date) {
  const duration = dayjs.duration(dayjs().diff(dayjs(date)))
  const days = duration.asDays();
  if (days < 1) {
    return 'today'
  } else if (days > 60) {
    return 'over 60 days ago'
  } else {
    return `${Math.floor(days)} days ago`
  }
}


export function normalizeUrl(text = '') {
  try {
    const expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
    if (text.match(expression)) {
      return _normalizeUrl(text);
    }
    return text;
  } catch (e) {
    return text;
  }
}

export function numberWithCommas(value: number = 0) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}